import React from 'react';
import { Col, Space, Row, Typography, Card } from 'antd';
import styled from 'styled-components';
import { COLORS, FONT_WEIGHTS, TEXT_SIZES } from '../../../utils/constants';
import { FacilitySportDto } from '../../../types/types';

interface SportOverviewProps {
  isSelected: boolean;
  facilitySport: FacilitySportDto;
  onDeleteSport: (facilitySport: FacilitySportDto) => void;
  onEditSport: () => void;
  onSportClick: () => void;
}

const SportOverviewCard: React.FC<SportOverviewProps> = ({
  isSelected,
  facilitySport,
  onDeleteSport,
  onEditSport,
  onSportClick,
}) => {
  return (
    <StyledCard onClick={() => onSportClick()} isSelected={isSelected}>
      <StyledTitle>{facilitySport.sportName}</StyledTitle>
      <Col span={24}>
        <RatesRow>
          <Row>
            <Label>Weekday(₹/hr)</Label>
            <Value>{facilitySport.regularHourlyPrice}</Value>
          </Row>
          <Row>
            <Label>Weekend(₹/hr)</Label>
            <Value>{facilitySport.weekendHourlyPrice}</Value>
          </Row>
        </RatesRow>

        <CourtsRow isSelected={isSelected}>
          <CourtsLabel>Courts</CourtsLabel>
          <Value>{facilitySport.totalCourts}</Value>
        </CourtsRow>

        <StyledSpaceWrapper>
          <StyledActionButton
            onClick={(e) => {
              e.stopPropagation();
              onEditSport();
            }}
          >
            Edit Sport
          </StyledActionButton>
          <StyledActionButton
            onClick={(e) => {
              e.stopPropagation();
              onDeleteSport(facilitySport);
            }}
          >
            Delete
          </StyledActionButton>
        </StyledSpaceWrapper>
      </Col>
    </StyledCard>
  );
};

export default SportOverviewCard;

const StyledCard = styled(Card)<{ isSelected: boolean }>`
  flex: 1;
  border-radius: 16px;
  cursor: pointer;
  border: 1px solid ${COLORS.grey.secondary};
  .ant-card-body {
    padding: 14px 4px;
    background-color: ${(props) =>
      props.isSelected ? COLORS.skyBlue.secondary : COLORS.white.primary};
    border-radius: 16px;
  }
`;

const StyledTitle = styled(Typography.Text)`
  font-size: ${TEXT_SIZES.MD}px !important;
  font-weight: ${FONT_WEIGHTS.SEMIBOLD} !important;
  margin-bottom: 20px !important;
  color: ${COLORS.blue.primary} !important;
  padding: 0px 12px;
`;

export const Label = styled(Typography.Text)`
  display: block;
  color: ${COLORS.grey.secondary};
  font-size: ${TEXT_SIZES.SM};
  margin: 0px 10px 4px 0px;
  font-weight: ${FONT_WEIGHTS.MEDIUM};
`;

export const Value = styled(Typography.Text)`
  display: block;
  font-size: ${TEXT_SIZES.SM};
  font-weight: ${FONT_WEIGHTS.SEMIBOLD};
`;

const StyledActionButton = styled.span`
  color: ${COLORS.skyBlue.primary};
  cursor: pointer;
  margin-right: 15px;
  padding: 2px;
  border-radius: 6px;
  &:hover {
    background-color: ${COLORS.grey.secondaryLight};
  }
`;

const StyledSpaceWrapper = styled(Space)`
  &.ant-space {
    gap: 0px !important;
    padding: 0px 12px;
  }
`;

export const RatesRow = styled(Row)`
  display: flex;
  justify-content: space-between;
  padding: 0px 12px;
`;

export const CourtsRow = styled(Row)<{ isSelected: boolean }>`
  display: flex;
  justify-content: space-between;
  background-color: ${(props) =>
    props.isSelected ? COLORS.white.primary : COLORS.grey.light};
  margin-bottom: 16px;
  padding: 4px 12px;
`;

export const CourtsLabel = styled(Typography.Text)`
  font-weight: ${FONT_WEIGHTS.MEDIUM};
  font-size: ${TEXT_SIZES.MD};
`;
